import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement } from 'lit/decorators.js';

import componentStyles from './pc-rectangle.css.lit';

/**
 * Tag component
 * @element pc-rectangle
 * @slot - This element has a default slot
 */
@customElement('pc-rectangle')
export class PCRectangle extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];

  render(): TemplateResult {
    return html` <span class="rectangle"></span> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-rectangle': PCRectangle;
  }
}
